import { render, staticRenderFns } from "./EquipmentView.vue?vue&type=template&id=2fc8bba5&scoped=true"
import script from "./EquipmentView.vue?vue&type=script&lang=js"
export * from "./EquipmentView.vue?vue&type=script&lang=js"
import style0 from "./EquipmentView.vue?vue&type=style&index=0&id=2fc8bba5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc8bba5",
  null
  
)

export default component.exports